// extracted by mini-css-extract-plugin
export default {"goldStyle":"goldStyle___OmcWf","borderStyle":"borderStyle___ZdHZE","greenStyle":"greenStyle___gfbrA","greenIconStyle":"greenIconStyle___tP7eV"};